import {config} from "@/constants/config";
import type {TResponseRequest} from "@/interfaces/http.interface";
import httpRequest from "@/providers/http/request.http";

export interface FxRateConfig {
  id: string;
  from_currency: string;
  to_currency: string;
  api_source: string;
  spread_adjustment_pct: string;
  auto_update_enabled: boolean;
  update_interval_minutes: number;
  last_api_rate: string | null;
  last_api_update: string | null;
  is_active: boolean;
  created_at: string;
  updated_at: string;
}

export interface CreateFxRateConfigDto {
  from_currency: string;
  to_currency: string;
  api_source?: string;
  spread_adjustment_pct?: string;
  auto_update_enabled?: boolean;
  update_interval_minutes?: number;
}

export interface UpdateFxRateConfigDto {
  spread_adjustment_pct?: string;
  auto_update_enabled?: boolean;
  update_interval_minutes?: number;
  is_active?: boolean;
}

export const getFxRateConfigsService = async (): Promise<TResponseRequest<FxRateConfig[]>> => {
  return httpRequest.get<FxRateConfig[]>({
    url: `${config.walletApiUrl}/bo/fx-rate-configs`,
  });
};

export const getFxRateConfigByIdService = async (id: string): Promise<TResponseRequest<FxRateConfig>> => {
  return httpRequest.get<FxRateConfig>({
    url: `${config.walletApiUrl}/bo/fx-rate-configs/${encodeURIComponent(id)}`,
  });
};

export const createFxRateConfigService = async (
  body: CreateFxRateConfigDto
): Promise<TResponseRequest<FxRateConfig>> => {
  return httpRequest.post<FxRateConfig>({
    url: `${config.walletApiUrl}/bo/fx-rate-configs`,
    body: body as unknown as Record<string, unknown>,
  });
};

export const updateFxRateConfigService = async (
  id: string,
  body: UpdateFxRateConfigDto
): Promise<TResponseRequest<FxRateConfig>> => {
  return httpRequest.put<FxRateConfig>({
    url: `${config.walletApiUrl}/bo/fx-rate-configs/${encodeURIComponent(id)}`,
    body: body as unknown as Record<string, unknown>,
  });
};

export const deleteFxRateConfigService = async (id: string): Promise<TResponseRequest<void>> => {
  return httpRequest.delete<void>({
    url: `${config.walletApiUrl}/bo/fx-rate-configs/${encodeURIComponent(id)}`,
    body: {},
  });
};
